import React from "react";

const OutlinedLocationIcon = ({
	width = "25",
	height = "24",
	color = "#827485",
	...props
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.4997 7.62256C11.3719 7.62256 10.6426 8.423 10.6426 9.19061C10.6426 9.95823 11.3719 10.7587 12.4997 10.7587C13.6276 10.7587 14.3569 9.95823 14.3569 9.19061C14.3569 8.423 13.6276 7.62256 12.4997 7.62256ZM8.64258 9.19061C8.64258 7.1231 10.4733 5.62256 12.4997 5.62256C14.5261 5.62256 16.3569 7.1231 16.3569 9.19061C16.3569 11.2581 14.5261 12.7587 12.4997 12.7587C10.4733 12.7587 8.64258 11.2581 8.64258 9.19061Z"
			fill={color}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.5 4C8.9757 4 6.5 6.5151 6.5 9.19055C6.5 10.6911 7.44957 12.8045 8.95182 15.0667C10.1356 16.8493 11.498 18.4855 12.5043 19.6158C13.508 18.4841 14.8673 16.8488 16.0491 15.0674C17.5503 12.8046 18.5 10.6913 18.5 9.19055C18.5 6.5151 16.0243 4 12.5 4ZM11.6314 21.6302C12.0886 22.1233 12.9229 22.1233 13.38 21.6302C15.4486 19.3806 20.5 13.4741 20.5 9.19055C20.5 5.2152 16.9229 2 12.5 2C8.07714 2 4.5 5.2152 4.5 9.19055C4.5 13.4741 9.55143 19.3806 11.6314 21.6302Z"
			fill={color}
		/>
	</svg>
);

export default OutlinedLocationIcon;
